import { render, staticRenderFns } from "./HelpDeskEddyChat.vue?vue&type=template&id=38d7a6b3&scoped=true&lang=pug&"
import script from "./HelpDeskEddyChat.vue?vue&type=script&lang=ts&"
export * from "./HelpDeskEddyChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7a6b3",
  null
  
)

export default component.exports